export default __webpack_public_path__ + "static/media/ba14.bf16227d.jpg";